import React, { useEffect, useRef } from "react";
import { MESSAGE } from "../../../utils/message";
import { EditProfileSection, Title } from "./EditProfileStyle";
import OrganizationProfile from "./organizationProfile";
import MediaProfile from "./mediaProfile";
import ImpactProfile from "./impactProfile";
import AdditionalInformation from "./additionalInformation";
import { useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { commonCountriesDataHandler, commonIssuesDataHandler, commonStatesDataHandler, fetchNonprofitProfileHandler } from "../../../redux/slices/myNonprofit/editnonprofit-slice";

type SectionId = 'organization' | 'media' | 'impact' | 'additional';
interface LocationState {
    sectionId?: SectionId;
}

const EditProfile: React.FC = () => {
    const { id } = useParams()
    const organizationRef = useRef<HTMLDivElement>(null);
    const mediaRef = useRef<HTMLDivElement>(null);


    const impactRef = useRef<HTMLDivElement>(null);
    const additionalRef = useRef<HTMLDivElement>(null);
    const nonprofitProfile: any = useSelector((state: any) => state?.editNonprofitProfile?.data?.results);

    const location = useLocation();
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(commonStatesDataHandler() as any)
        dispatch(commonCountriesDataHandler() as any)
        dispatch(commonIssuesDataHandler() as any)

        if (id) {
            dispatch(fetchNonprofitProfileHandler(id) as any);
        }
        const state = location.state as LocationState;
        setTimeout(() => {
            if (state?.sectionId) {
                const sectionRefMap: Record<SectionId, React.RefObject<HTMLDivElement>> = {
                    organization: organizationRef,
                    media: mediaRef,
                    impact: impactRef,
                    additional: additionalRef,
                };
                const sectionRef = sectionRefMap[state.sectionId];
                if (sectionRef?.current) {
                    sectionRef.current.scrollIntoView({
                        behavior: "auto",
                        inline: "nearest",

                    });

                }
            }
        }, 500)
    }, [location.state]);


    return (
        <EditProfileSection>
            <Title>{MESSAGE.editProfile}</Title>

            <div ref={organizationRef} id="organization">
                <OrganizationProfile />
            </div>

            <div ref={mediaRef} id="media">
                <MediaProfile />
            </div>

            <div ref={impactRef} id="impact">
                <ImpactProfile />
            </div>

            <div ref={additionalRef} id="additional">
                <AdditionalInformation />
            </div>
        </EditProfileSection>
    );
};

export default EditProfile;